<ng-container *ngIf="loading">
    <div class="loading text-center">
        <br />
        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
        <br />
        <p>Loading assessments, please wait...</p>
    </div>
</ng-container>

<ng-container *ngIf="!loading">
    <br />
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8">
                <!--<p></p>-->
            </div>
            <div class="col-md-4">
                <div class="text-right">
                    <i class="material-icons" (click)="showModal()">add</i>
                    <i (click)="getSelected()" class="material-icons">delete</i>
                </div>
            </div>
        </div>

        <br />
        <div>
            <div class="" style="width: 100%; max-height: 400px; height:400px;">
                <ag-grid-angular #agGrid
                                style="width: 100%; height: 100%;"
                                class="ag-theme-balham"
                                [enableFilter]="true"
                                [gridOptions]="gridOptions"
                                [rowData]="raters"
                                [columnDefs]="ratersHeaders"
                                [enableSorting]="true"
                                [enableColResize]="true"
                                (rowClicked)="onRowClicked($event)"
                                (gridReady)="onGridReady($event)"
                                [pagination]="true"
                                [paginationPageSize]="25"
                                [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                [animateRows]="true"
                                [rowDragManaged]="true"
                                [rowMultiSelectWithClick]="true"
                                [rowSelection]="rowSelection">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</ng-container>


<div id="addModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add Rater</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div class="row">
                    <div class="col-xs-12 col-md-3">
                        <label>Email:</label>
                    </div>
                    <div class="col-xs-12 col-md-9">
                        <input #email
                               id="email" 
                               type="email"
                               placeholder="Email"
                               [(ngModel)]="rater.email"
                               (keypress)="preventSpace(email.value, $event, 'email')"
	                           (keyup)="preventSpace(email.value, $event, 'email')" />
                    </div>
                </div>

                <!--<div class="row">
                    <div class="col-xs-12 col-md-3">
                        <label>First Name:</label>
                    </div>
                    <div class="col-xs-12 col-md-9">
                        <input #firstName
                               id="firtName" 
                               type="text"
                               placeholder="First name"
                               [(ngModel)]="rater.firstName"
                               (keypress)="preventSpace(firstName.value, $event, 'firtName')"
	                           (keyup)="preventSpace(firstName.value, $event, 'firtName')" />
                    </div>
                </div>-->

                <!--<div class="row">
                    <div class="col-xs-12 col-md-3">
                        <label>Last name:</label>
                    </div>
                    <div class="col-xs-12 col-md-9">
                        <input #lastName
                               id="lastName" 
                               type="text"
                               placeholder="Last name"
                               [(ngModel)]="rater.lastName"
                               (keypress)="preventSpace(firstName.value, $event, 'lastName')"
	                           (keyup)="preventSpace(firstName.value, $event, 'lastName')" />
                    </div>
                </div>-->

                <div class="row">
                    <div class="col-xs-12 col-md-3">
                        <label>Relationship:</label>
                    </div>
                    <div class="col-xs-12 col-md-9">
                        <select #raterType
                                [(ngModel)]="rater.raterType">
                            <option *ngFor="let rt of raterTypes" value="{{rt.Id}}">{{rt.Name}}</option>
                        </select>
                    </div>
                </div>

            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="closeModal()" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        <button (click)="saveRater()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
